import { ColDef } from "ag-grid-community";
import { jiraIssuesColumnDef } from "../common/jiraIssuesColumnDef";
import { tagsColumnDef } from "../common/tagsColumnDef";
import { smartTagsColumnDef } from "../common/smartTagsColumnDef";
import { resourceTotalSpendColumnDef } from "../common/resourceTotalSpendColumnDef";
import { getResourceCreationTimeColumnDef } from "../common/getResourceCreationTimeColumnDef";
import { forecastedEOMColumnDef } from "../common/forecastedEOMColumnDef";
import { resourceUnusedSinceCellRenderer } from "../common/resourceUnusedSinceCellRenderer";
import { getResourceIdentifierColumnDef } from "@/components/pages/common/resources-ag-grid/components/column-defs/common/getResourceIdentifierColumnDef";
import { getResourceMetricsColumnDef } from "@/components/pages/common/resources-ag-grid/components/column-defs/common/getResourceMetricsColumnDef";
import { taskColumnDef } from "@/components/pages/common/resources-ag-grid/components/column-defs/common/taskColumnDef";
import { billingCostColumnDef } from "@/components/pages/common/resources-ag-grid/components/column-defs/common/billingCostColumnDef";
import { getListingPriceColumnDef } from "@/components/pages/common/resources-ag-grid/components/column-defs/common/listingPriceColumnDef";

export const asgEc2ColumnDefs: ColDef[] = [
  getResourceIdentifierColumnDef(),

  { field: "resource.instance_id", headerName: "Instance-id" },

  forecastedEOMColumnDef,
  billingCostColumnDef,
  getListingPriceColumnDef("asg_ec2"),

  resourceUnusedSinceCellRenderer,

  getResourceMetricsColumnDef("CPU Max", "cpu_max", "asg_ec2"),

  {
    hide: true,
    ...getResourceMetricsColumnDef(
      "Memory Utilization Max",
      "mem_used_percent_max",
      "asg_ec2",
    ),
  },
  {
    hide: true,
    ...getResourceMetricsColumnDef(
      "Memory Available Min",
      "mem_available_percent_min",
      "asg_ec2",
    ),
  },

  resourceTotalSpendColumnDef,

  getResourceCreationTimeColumnDef("Launch Time"),

  { field: "resource.type", headerName: "Instance Type" },

  tagsColumnDef,
  smartTagsColumnDef,
  taskColumnDef,
  jiraIssuesColumnDef,
];
